import React, { useEffect, useRef, useState } from "react";
import "./header.css";
import SmallScreenHeader from "./SmallScreenHeader";
import logo from "../../media/images/logo.png";
import tiktokIcon from "../../media/images/tiktokIcon.png";
import instagramIcon from "../../media/images/instagramIcon.png";
import callIcon from "../../media/images/callIcon.png";
import whatsappIcon from "../../media/images/whatsappIcon.png";

const Header = () => {
    const [displayNav, setDisplayNav] = useState(false);
    const [visible, setVisible] = useState(true);
    const [prevY, setPrevY] = useState(window.scrollY);
    const header = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const currentY = window.scrollY;
            if (prevY > currentY && prevY - currentY > 5) {
                setVisible(true);
            } else if (currentY > prevY && currentY - prevY > 5) {
                setVisible(false);
            }
            setPrevY(currentY);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [prevY]);

    useEffect(() => {
        if (header.current) {
            header.current.style.transition = "transform 0.3s";
            header.current.style.transform = visible
                ? "translateY(0)"
                : "translateY(-220px)";
        }
    }, [visible]);

    return (
        <header ref={header} className="big_screen">
            <button
                onClick={() => {
                    setDisplayNav(true);
                }}
            >
                <i className="bi bi-list"></i>
            </button>
            <img src={logo} alt="Logo" />

            <nav>
                <ul>
                    <li>
                        <a href="#">בית</a>
                    </li>
                    <li>
                        <a href="#about">אודות</a>
                    </li>
                    <li>
                        <a href="#services">מה אנחנו עושים</a>
                    </li>
                    <li>
                        <a href="#works">העבודות שלנו</a>
                    </li>
                    <li>
                        <a href="#faq">שאלות & תשובות</a>
                    </li>
                    <li>
                        <a href="#contact">צרו קשר</a>
                    </li>
                </ul>
            </nav>

            <div className="socials">
                <a
                    href="https://www.tiktok.com/@batim.v.ganim?_t=8kaulOtu71z&_r=1&fbclid=PAZXh0bgNhZW0CMTEAAafL2aNBLTI3AgWGpwYnxQSWGDbSG7iZF-dLqr1V-4DmEgWNPj20WwpnCQES0w_aem_j-Wwqw-5CaoJ1yFCHIpSuQ"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={tiktokIcon} alt="Tiktok icon" />
                </a>
                <a
                    href="https://www.instagram.com/dudi_house_garden?utm_source=qr&igsh=MWlqYWx5am9vMXp2Mw%3D%3D"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={instagramIcon} alt="Instagram icon" />
                </a>
                <a href="tel:0544361266">
                    <img src={callIcon} alt="Call icon" />
                </a>
                <a
                    href="https://wa.me/972544361266"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={whatsappIcon} alt="Whatsapp icon" />
                </a>
            </div>
            {displayNav && (
                <SmallScreenHeader
                    setDisplayNav={setDisplayNav}
                    displayNav={displayNav}
                />
            )}
        </header>
    );
};

export default Header;
